import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/chemistry/elements/components/x-grid.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Simple Collapsable that uses an attribute scan to add on-demand event listeners for toggling collapse state
@customElement('ils-simple-collapsable')
export class ILSSimpleCollapsable extends ChemistryLitElement {
  @property({ type: Boolean }) private collapsed = false;

  override styles() {
    return [
      {
        ':host': {
          '.exd-collapsable': {
            transition: 'all .3s ease',
            opacity: '0',
            overflow: 'hidden',
            gridTemplateRows: '0fr',
            '.exd-collapsable-content': {
              overflow: 'hidden',
            },
            '&.expanded': {
              opacity: '1',
              gridTemplateRows: '1fr',
            },
          },
        },
      },
    ];
  }

  override render() {
    return html`
      <x-flex space="${this.collapsed ? '' : 'sm'}">
        <div>
          <slot name="static"></slot>
        </div>
        <x-grid space="sm" spacing="md" class="exd-collapsable ${!this.collapsed ? 'expanded' : ''}">
          <div class="exd-collapsable-content">
            <slot name="content"></slot>
          </div>
        </x-grid>
      </x-flex>
    `;
  }

  override connectedCallback(): void {
    super.connectedCallback();

    this.addToggleEvents();
  }

  override disconnectedCallback(): void {
    super.disconnectedCallback();

    this.removeToggleEvents();
  }

  private addToggleEvents() {
    // Attach click event listeners to buttons inside the slots
    const toggleElements = this.querySelectorAll('[toggle]');
    toggleElements.forEach(el => {
      el.addEventListener('click', this.toggleCollapsed.bind(this));
    });
  }

  private removeToggleEvents() {
    // Remove the event listener when the element is disconnected
    const toggleElements = this.querySelectorAll('[toggle]');
    toggleElements.forEach(el => {
      el.removeEventListener('click', this.toggleCollapsed.bind(this));
    });
  }

  private toggleCollapsed() {
    this.collapsed = !this.collapsed;
    this.dispatchEvent(new CustomEvent('toggle', { detail: { value: this.collapsed } }));
  }

  // Rescan on update
  override updated(changedProperties: Map<string | number | symbol, unknown>): void {
    super.updated(changedProperties);

    if (changedProperties.has('childNodes')) {
      this.removeToggleEvents();
      this.addToggleEvents();
    }
  }
}
